/* Pattounes : jeu des planches (Katsu Sensei) */
(function(){
  function init(root){
    var MAXD=parseInt(root.getAttribute('data-max'),10)||15;
    var CODE=root.getAttribute('data-code')||'';
    var REWARD=root.getAttribute('data-reward')||'';
    var IMG={k:root.getAttribute('data-img-k'),m:root.getAttribute('data-img-m'),d:root.getAttribute('data-img-d')};
    var $=function(s){return root.querySelector(s)};
    var a=$('[data-k]'),b=$('[data-m]'),n=$('[data-n]'),dy=$('[data-day]'),bar=$('[data-bar]'),
        nx=$('[data-next]'),ul=$('[data-tiers]'),go=$('[data-go]'),rs=$('[data-reset]');
    var L=[["HIYAAH ! Une planche de plus, un prix de moins dans mon viseur !","Fort bien, Katsu. Mais cette planche-là n'était pas dans le budget."],
    ["CRAC ! Le prix de la gamelle est à terre !","Permettez-moi de vous guider vers la sélection du jour."],
    ["Un vrai maître ne négocie pas avec les prix. Il les casse.","Et moi, je les range. Nous sommes fort complémentaires."],
    ["KIAI ! Encore une planche, encore une victoire !","Katsu, le budget vient de rendre son tablier."],
    ["Mon papa humain dit que je suis têtu. Moi, je dis : déterminé !","Un caractère bien trempé. Cela dit, on ne casse pas le mobilier."],
    ["HIYAAH ! Même mon ombre a peur de cette planche !","Votre ombre est plus raisonnable que vous, cher ami."]];
    var T=[[5,'Ceinture jaune',"Fond d'écran Katsu Sensei",'img',IMG.k,'Katsu-Sensei-fond-ecran.jpg','#FFE233'],
    [10,'Ceinture orange',"Fond d'écran Sir Moustache",'img',IMG.m,'Sir-Moustache-fond-ecran.jpg','#F28C28'],
    [20,'Ceinture verte',"Fond d'écran du duo, Katsu et Sir Moustache",'img',IMG.d,'Katsu-et-Sir-Moustache-fond-ecran.jpg','#2E8B57'],
    [40,'Ceinture noire',REWARD,'code',CODE,'','#1B1B1B']];
    var KEY='pattounes-planches',KD='pattounes-jour',c=0,i=0,lastHit=0;
    function today(){return new Date().toISOString().slice(0,10)}
    function getDay(){try{var o=JSON.parse(localStorage.getItem(KD)||'null');if(o&&o.d===today())return o.n}catch(e){}return 0}
    function setDay(v){try{localStorage.setItem(KD,JSON.stringify({d:today(),n:v}))}catch(e){}}
    try{c=parseInt(localStorage.getItem(KEY),10)||0}catch(e){}
    function save(){try{localStorage.setItem(KEY,String(c))}catch(e){}}
    function say(x,y){a.textContent=x;b.textContent=y}
    function download(url,name){
      fetch(url).then(function(r){return r.blob()}).then(function(bl){
        var u=URL.createObjectURL(bl),l=document.createElement('a');l.href=u;l.download=name;document.body.appendChild(l);l.click();l.remove();
        setTimeout(function(){URL.revokeObjectURL(u)},2000);
      }).catch(function(){window.open(url,'_blank','noopener')});
    }
    function render(){
      n.textContent='Planches cassées : '+c;
      var d=getDay();dy.textContent="Aujourd'hui : "+d+'/'+MAXD;dy.style.marginLeft='1rem';
      go.disabled=d>=MAXD;
      var prev=0,nxt=null;
      for(var j=0;j<T.length;j++){if(c<T[j][0]){nxt=T[j];break}prev=T[j][0]}
      var pct=nxt?Math.round((c-prev)/(nxt[0]-prev)*100):100;
      bar.style.width=pct+'%';bar.parentNode.setAttribute('aria-valuenow',String(pct));
      nx.textContent=nxt?'Encore '+(nxt[0]-c)+' planche'+(nxt[0]-c>1?'s':'')+' pour la '+nxt[1].toLowerCase()+'.':'Ceinture noire atteinte. Respect, maître.';
      ul.textContent='';
      T.forEach(function(t){
        var open=c>=t[0],li=document.createElement('li');li.className=open?'open':'lock';
        var sw=document.createElement('span');sw.className='pt-sw';sw.style.background=t[6];
        var dv=document.createElement('div');
        var nm=document.createElement('div');nm.className='pt-nm';nm.textContent=t[1]+' ('+t[0]+' planches)';
        var rw=document.createElement('div');rw.className='pt-rw';rw.textContent=t[2];
        dv.appendChild(nm);dv.appendChild(rw);
        var act=document.createElement('div');act.className='pt-act';
        if(open){
          if(t[3]==='img'){
            var l=document.createElement('button');l.type='button';l.className='pt-dl';l.textContent='Télécharger';
            l.addEventListener('click',function(){download(t[4],t[5])});act.appendChild(l);
          }else{
            var code=document.createElement('code');code.textContent=t[4];
            var cp=document.createElement('button');cp.type='button';cp.className='pt-dl';cp.textContent='Copier';cp.style.marginLeft='.6rem';
            cp.addEventListener('click',function(){
              try{navigator.clipboard.writeText(t[4]).then(function(){cp.textContent='Copié !';setTimeout(function(){cp.textContent='Copier'},1500)})}catch(e){}
            });
            act.appendChild(code);act.appendChild(cp);
          }
        }else{act.textContent='Verrouillé'}
        li.appendChild(sw);li.appendChild(dv);li.appendChild(act);ul.appendChild(li);
      });
    }
    function hit(){
      var now=Date.now();if(now-lastHit<700)return;lastHit=now;
      var d=getDay();
      if(d>=MAXD){say("Mes mains sont en feu... Je reviens demain !","Katsu doit se reposer. Revenez demain pour d'autres planches.");render();return}
      c++;d++;i=(i+1)%L.length;save();setDay(d);
      var t=T.filter(function(x){return x[0]===c})[0];
      if(t)say("KIAI ! "+t[1].toUpperCase()+" !","Récompense débloquée : "+t[2].charAt(0).toLowerCase()+t[2].slice(1)+". Fort aimable.");
      else say(L[i][0],L[i][1]);
      render();
    }
    say(L[0][0],L[0][1]);render();
    go.addEventListener('click',hit);
    if(location.hash==='#test'&&rs){rs.hidden=false;rs.addEventListener('click',function(){c=0;i=0;save();setDay(0);say(L[0][0],L[0][1]);render()})}
  }
  function boot(){document.querySelectorAll('[id^="pt-jeu-"]').forEach(function(r){if(!r.__pt){r.__pt=1;init(r)}})}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();